module.exports = __webpack_public_path__ + "static/media/Apple.3b14797b.svg";